import { render, staticRenderFns } from "./Extrachargetypemanagement.vue?vue&type=template&id=1b4ff5f5&scoped=true&"
import script from "./Extrachargetypemanagement.vue?vue&type=script&lang=js&"
export * from "./Extrachargetypemanagement.vue?vue&type=script&lang=js&"
import style0 from "./Extrachargetypemanagement.vue?vue&type=style&index=0&id=1b4ff5f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ff5f5",
  null
  
)

export default component.exports